import { render, staticRenderFns } from "./BenchmarkCard.vue?vue&type=template&id=2023b156"
import script from "./BenchmarkCard.vue?vue&type=script&lang=js"
export * from "./BenchmarkCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports